import {foundationTheme} from 'platform/foundation';

export const getActivitySidebarWidthCss = (width: number) =>
  `calc(var(--eag-space-step, ${foundationTheme.space.step}) * ${width}rem)` as const;
